var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKodpex({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 306,
    height: 100,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.052 70.69H20V29.803h9.052v18.173h18.101V43.43h4.526v-4.544h4.526v-9.085h9.052v9.085H60.73v4.544h-4.526v4.544h-4.526v4.543h4.526v4.544h4.526v4.543h4.526v9.086h-9.052v-9.086h-4.526v-4.543h-4.526v-4.544H29.052v18.173Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.226 38.887h36.214v4.544h4.511v13.63h-4.52v4.544H66.216v-4.543H61.7V43.43h4.526v-4.544Zm31.679 4.544H70.75v13.63h27.154v-13.63ZM112.848 38.84h31.679V20.666h9.05v40.89h-40.729v-4.534h-4.526v-13.64h4.526v-4.544Zm4.526 18.183h27.153v-13.64h-27.153v13.64ZM195.617 61.605h-31.679v18.173h-9.052v-40.89h40.731v4.543h4.535v13.63h-4.535v4.544Zm-4.526-18.174h-27.153v13.63h27.153v-13.63ZM210.165 57.023h18.113v4.543h-22.63v-4.543h-4.533v-13.64h4.524v-4.544h36.205v4.544h4.526v9.087h-36.214l.009 4.553Zm0-9.088h27.153v-4.552h-27.153v4.552Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.743 27.482h9.043v9.087h4.526v4.542h4.525v4.544h9.052V41.11h4.524V36.57h4.526v-9.087H286v9.087h-4.526v4.542h-4.526v4.544h-4.526v4.54h4.526v4.543h4.526v4.544H286v9.085h-9.052v-9.082h-4.526v-4.543h-4.524v-4.547h-9.051v4.543h-4.526v4.544h-4.535v9.085h-9.05v-9.082h4.524v-4.543h4.526v-4.547h4.526v-4.54h-4.526V41.11h-4.526V36.57h-4.524l.007-9.087Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 306,
    height: 99.111,
    x: 0,
    y: 0.667,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0352941 0 0 0 0 1 0 0 0 0 0.988235 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_399_667"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_399_667",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKodpex);
export default __webpack_public_path__ + "static/media/kodpex.e00e1041146175428525ef35c2dadff5.svg";
export { ForwardRef as ReactComponent };